import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { BatteryTrainingMode, BatteryTrainingModes } from 'src/Libs/system-data-handler'

interface Props {
  trainingMode: BatteryTrainingMode
}

const BatteryTrainingModeIndicator: React.VFC<Props> = ({ trainingMode }) => {
  const theme = useTheme()
  const { t } = useCustomTranslation()

  return (
    <Box
      sx={{
        borderRadius: 2,
        backgroundColor: trainingMode === BatteryTrainingModes.Inactive ? theme.palette.primary.light : theme.palette.error.light,
        color: trainingMode === BatteryTrainingModes.Inactive ? theme.palette.grey.grey02 : theme.palette.grey.grey07,
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 1,
        paddingBottom: 1,
      }}
    >
      <Typography>
        {trainingMode === BatteryTrainingModes.Active
          ? t('settings.battery.battery-training.status.active')
          : t('settings.battery.battery-training.status.inactive')}
      </Typography>
    </Box>
  )
}

export default BatteryTrainingModeIndicator
